import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function redirectToHomeIfAuthorised() {
  if (sessionStorage.getItem("logging_out")) {
    sessionStorage.removeItem("logging_out");
    return undefined;
  }

  const authorisationStore = useAuthorisationStore();
  const authClient = await getAuthClient();
  const token = await authClient.getAccessToken();
  if (token) {
    if (authorisationStore.redirectToAfterLoginUrl === "/auth/login") {
      authorisationStore.redirectToAfterLoginUrl = undefined;
    }

    return authorisationStore.getRedirectToAfterLoginUrl || { name: "dashboard" };
  }
  return undefined;
}
